import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import {ru} from "vuetify/src/locale";

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { ru },
    current: "ru"
  },
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: {
          // Green
          /*base: "#1a965a",
          darken1: "#4aac7d",
          lighten3: "#b3dbc9",
          lighten4: "#bbe0cf",
          lighten5: "#d1eade"*/

          base: "#1b4792",
          darken1: "#2F5084", //"rgb(47,80,132)",//"#3c6ebf",
          lighten3: "#6371A0", //"rgb(99,113,160)",//"#4f7dc9",
          lighten4: "#7E87AA", //"rgb(126,135,170)",//"#6988c9",
          lighten5: "#d9e0f7"
        },
        secondary: {
          // Black
          base: "#030724",
          darken4: "#000000",
          lighten1: "#525e74",
          lighten2: "#686a7c",
          lighten3: "#8a92a0",
          lighten4: "#999999",
          lighten5: "#f2f2f2"
        },
        error: {
          // Red
          base: "#e41e26",
          darken4: "#de464b",
          lighten4: "#de6e73",
          lighten5: "#e8999e"
        },
        info: {
          // Blue
          base: "#3474c5",
          darken4: "#316da3",
          darken2: "#157dab",
          lighten5: "#d6e3f3"
        },
        success: {
          // Green
          base: "#1b4792",
          lighten1: "#3474c5"
        },
        warning: {
          // Yellow
          base: "#d9ab36",
          lighten5: "#f7eed7"
        },
        background: {
          // Grey
          base: "#8f9cac",
          darken4: "#cccccc",
          darken2: "#f4f5f9",
          darken1: "#e4e4e4",
          lighten1: "#bcc5d1",
          lighten2: "#dce2ea",
          lighten3: "#ebeff5",
          lighten4: "#fff",
          lighten5: "#d5e3ef"
        },
        overlay: {
          base: "#b6b5c4"
        },
        contract: {
          base: "#d9e0f7"
        },
        chart: {
          base: "#fff",
          lighten1: "#fff",
          lighten2: "#bcc5d1",
          lighten3: "#dce2ea",
          lighten4: "#d1eade",
          lighten5: "#d6e3f3",
          darken1: "#030724",
          darken2: "#b1b6cd",
          darken3: "#3474c5",
          darken4: "#319f62",
        }
      }
    }
  }
});
